import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css'
import "./index.css";

document.addEventListener('click', function (event) {
    const menu = document.querySelector('.navbar-collapse');
    const menuOpen = menu !== null && menu.classList.contains('show');
    if (menuOpen && !event.target.classList.contains('navbar-toggler')) {
        document.querySelector('button.navbar-toggler').click();
    }
});
